import decorator from './server-rendering';

export default decorator;
